<template>
  <section class="section">
    <h2 class="sub-title">
      {{ personalDataSearch.searchRunner[lang] }}
    </h2>
    <p class="description">
      {{ personalDataSearch.description[lang] }}
    </p>
    <form name="data-search" class="user-detail-search" onsubmit="return false">
      <input
        type="text"
        inputmode="numeric"
        name="entry_id"
        id="user-detail-search__input"
        class="user-detail-search__input"
        :placeholder="personalDataSearch.placeholder[lang]"
      />
      <button
        type="submit"
        class="user-detail-search__button"
        @click="openModal"
        >{{ personalDataSearch.search[lang] }}</button
      >
      <p v-if="isBadRequest" class="user-detail-search__failure">
        {{ failureMessage }}
      </p>
    </form>
    <div
      class="overlay"
      id="overlay"
      v-if="showContent || isLoading"
      v-on:click="closeModal"
    >
      <Loading v-if="isLoading"></Loading>
    </div>
    <div class="user-detail-modal" v-if="showContent">
      <button class="user-detail-modal__close_button" v-on:click="closeModal">
        <img
          src="../../../../../static/company/ranking/ic_close.svg"
          alt="閉じる"
          width="30"
        />
      </button>
      <h3 class="user-detail-modal__title">{{
        personalDataSearch.modalTitle[lang]
      }}</h3>
      <hr />
      <div class="user-detail-modal__contents">
        <dl class="flex-dl detail-item">
          <dt class="detail-item__name">{{
            personalDataSearch.runnerName[lang]
          }}</dt>
          <dd class="detail-item__content">
            <img
              :src="`../../../../../static/company/ranking/${runnerDetailData.user.application}_icon.png`"
              :alt="runnerDetailData.user.application"
              width="32"
              class="app_icon"
            />
            <span v-if="runnerDetailData.user.name">
              {{ runnerDetailData.user.name }}
            </span>
            <span v-else class="not-coordinated">
              {{ personalDataSearch.noAuth[lang] }}
            </span>
          </dd>
        </dl>
        <dl class="flex-dl detail-item">
          <dt class="detail-item__name">{{ personalDataSearch.team[lang] }}</dt>
          <dd class="detail-item__content">
            {{ runnerDetailData.company.name }}
          </dd>
        </dl>
        <dl class="detail-item">
          <dt class="detail-item__name">{{
            personalDataSearch.record[lang]
          }}</dt>
          <dd v-if="hasRunData" class="detail-item__content run-record">
            <table class="marathon-data-table">
              <tr
                v-for="(record, index) in convertedRecords"
                :key="index"
                class="marathon-data-table__tr"
              >
                <td class="marathon-data-table__td" v-if="record.date">
                  {{ record.date }}
                </td>
                <td
                  class="marathon-data-table__td marathon-data-table__time"
                  v-if="record.time"
                >
                  {{ record.time }}
                </td>
                <td
                  class="marathon-data-table__td marathon-data-table__distance"
                  v-if="record.distance"
                >
                  {{ record.distance }}
                </td>
              </tr>
            </table>
          </dd>
          <dd v-else class="user-detail-modal__no_data">{{
            personalDataSearch.noRecordMessage[lang]
          }}</dd>
        </dl>
      </div>
    </div>
  </section>
</template>

<script>
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import Loading from "../../../../components/pc/Loading";
import PersonalDataSearch from "../../../../assets/constants/company/ranking/personalDataSearch.json";
export default {
  data: function () {
    return {
      nassEventId: "",
      showContent: false,
      isLoading: false,
      hasRunData: true,
      runnerDetailData: null,
      convertedRecords: [],
      isBadRequest: false,
      entryId: null,
      recordLength: 0,
      failureMessage: "",
      personalDataSearch: PersonalDataSearch,
    };
  },
  created() {
    // イベントID取得
    this.nassEventId = sessionStorage.getItem("nassEventId");
  },
  methods: {
    openModal: async function () {
      this.isBadRequest = false;
      this.entryId = document.getElementById("user-detail-search__input").value;
      if (!this.entryId) {
        // 入力フォーム内が空
        this.isBadRequest = true;
        this.setEmptyMessage();
        return;
      }
      const runnerData = await this.getRunnerDetail();
      if (runnerData === null) {
        // 個人データ取得失敗
        return;
      }
      if (!this.recordLength) {
        // 記録なし
        this.hasRunData = false;
      }
      this.runnerDetailData = runnerData.entries_records;
      this.convertedRecords = runnerData.converted_records;
      this.showContent = true;
    },
    closeModal: function () {
      this.hasRunData = true;
      this.showContent = false;
    },
    getRunnerDetail: async function () {
      // ランナー情報取得
      const RankingRepository = RepositoryFactory.get("ranking");
      this.isLoading = true;
      let runnerData = null;
      try {
        const response = await RankingRepository.getTeamRunnerRecords({
          nass_event: this.nassEventId,
          entry_id: this.entryId,
        });
        runnerData = response.data;
        this.recordLength = runnerData.entries_records.records.length;
      } catch (e) {
        this.isBadRequest = true;
        if (e.response.status === 404) {
          this.setWrongIdMessage();
          return runnerData;
        }
        this.setBadRequestMessage();
      } finally {
        this.isLoading = false;
      }
      return runnerData;
    },
    setWrongIdMessage: function () {
      // エントリーIDが見つからなかった際のエラーメッセージ
      this.failureMessage =
        "エントリーID" + this.entryId + "は見つかりませんでした。";
    },
    setBadRequestMessage: function () {
      // 400や500でデータが取得できなかった際のエラーメッセージ
      this.failureMessage = "データを取得できませんでした。";
    },
    setEmptyMessage: function () {
      // 入力フォーム内が空の際のエラーメッセージ
      this.failureMessage = "エントリーIDを入力してください。";
    },
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
  },
  components: {
    Loading,
  },
  name: "PersonalDataSearch",
};
</script>

<style scoped lang="scss">
.sub-title {
  font-size: 32px;
  font-weight: 900;
}

.description {
  font-size: 16px;
  margin: 15px 0 30px;
  line-height: normal;
  white-space: pre-line;
}

.user-detail-search {
  width: 100%;
  height: 140px;
  padding: 40px 40px 0 40px;
  background-color: #eee;

  &__input {
    width: 420px;
    height: 60px;
    font-size: 16px;
    padding: 0 0 0 30px;
    border: 1px solid #fff;
    margin: 0 15px 0 0;
    background-color: #fff;
    &::placeholder {
      color: #9b9b9b;
    }
  }

  &__button {
    width: 140px;
    height: 60px;
    border: #333333 solid 1px;
    background-color: #fff;
    padding: 10px;
    &:hover {
      color: #fff;
      background-color: #000;
    }
  }

  &__failure {
    padding-top: 10px;
    font-size: 14px;
  }
}

.overlay {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.user-detail-modal {
  z-index: 2;
  position: fixed;
  width: 640px;
  top: calc(50% - 490px / 2);
  left: calc(50% - 640px / 2);
  border-radius: 10px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  background: #fff;

  &__close_button {
    position: fixed;
    top: calc(50% - 490px / 2 + 10px);
    right: calc(50% - 640px / 2 + 10px);
  }

  &__title {
    font-size: 30px;
    text-align: center;
    padding: 40px 0 30px 0;
  }

  &__contents {
    padding: 10px 36px;

    .detail-item {
      padding: 15px 0;

      &__name {
        width: 176px;
        font-size: 20px;
        font-weight: bold;
      }

      &__content {
        font-size: 16px;
        flex: 1;
        .app_icon {
          margin: 0 10px 0 0;
        }
        .not-coordinated {
          color: #666;
        }
      }
    }

    .run-record {
      height: 200px;
      overflow-y: auto;
    }

    .marathon-data-table {
      width: 100%;
      border-collapse: collapse;

      &__tr {
        height: 56px;
        border-bottom: dashed 1px;
      }

      &__td {
        padding-right: 30px;
        word-break: break-word;
      }

      &__time,
      &__distance {
        font-weight: bold;
      }
    }
  }

  .flex-dl {
    display: flex;
    align-items: center;
  }

  .user-detail-modal__no_data {
    text-align: center;
    background: #eee;
    padding: 20px;
    border-radius: 4px;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/company/ranking/PersonalDataSearch.vue